import Api from '@sendsprint/api-types';
import { generateOtpService } from '@src/services/auth-service';
import ClientApi from '@src/types/client';
import { addTelCode } from '@src/utils/getCountryTelCode';
import { getState } from '@src/utils/stateStorage';
import { useField } from 'formik';
import { useState } from 'react';

interface UseOtpScreenOptions {
  queryValues:
    | {
        email: string | null;
        hash: string | null;
      }
    | undefined;
  user: ClientApi.General.UserProfile | null | undefined;
  handleStartTimer: (() => void) | undefined;
  changePhoneNumber: (() => void) | undefined;
}

const useOtpScreen = ({
  queryValues,
  user,
  handleStartTimer,
  changePhoneNumber
}: UseOtpScreenOptions) => {
  const field = useField('phone');
  const otpField = useField('otp');
  const [{ value: countryValue }] = useField('country');
  const phoneValue: string = field[0].value;
  const [resendLoading, setResendLoading] = useState(false);
  //
  const resendFunc = async () => {
    const state = getState();
    const hash = (state && state.tokens && state.tokens.hash) || queryValues?.hash || '';

    setResendLoading(true);

    const payload: Omit<ClientApi.Account.GenerateOtp.GenerateOtpI, 'otp'> = {
      email: user?.email || queryValues?.email || '',
      hash: hash,
      phone: addTelCode(
        (state?.address?.country || countryValue) as Api.Model.CountryInitials,
        field[0].value
      )
    };
    try {
      const res = await generateOtpService(payload);

      if (res?.data?.ResponseCode === Api.Endpoint.Response.Code.Successful) {
        if (handleStartTimer) {
          handleStartTimer();
        }
      }

      setResendLoading(false);
    } catch (error) {
      setResendLoading(false);
    }
  };

  const handleChangePhone = () => {
    if (changePhoneNumber) {
      changePhoneNumber();
    }

    otpField[2].setValue('');
  };

  return { handleChangePhone, resendFunc, resendLoading, phoneValue };
};

export default useOtpScreen;
